import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'map'
})
export class MapPipe implements PipeTransform {

  transform(values: any[] | null | undefined, expression: string): any[] {
    if (!Array.isArray(values)) {
      return [];
    }
    if (!expression) {
      return values;
    }

    const fn = eval(`(${expression})`);

    if (typeof fn !== 'function') {
      throw new Error(`MapPipe: expression must evaluate to a function. Got: ${typeof fn}`);
    }

    return values.map(fn);
  }

}
